import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ecommerce-privacidad',
  templateUrl: './ecommerce-privacidad.component.html',
  styleUrls: ['./ecommerce-privacidad.component.css']
})
export class EcommercePrivacidadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
